export const createCookie = (name: string, value: string, days?: number) => {
  let expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  } else {
    expires = '';
  }
  document.cookie = name + '=' + value + expires + '; path=/';
};

export const cookieExists = (name: string) => {
  const cookies = document.cookie.split(';');
  return cookies.some((cookieItem) => cookieItem.indexOf(`${name}=`) > -1);
};

export const readCookie = (cookieName: string) => {
  var cookieString = RegExp(cookieName + '=[^;]+').exec(document.cookie);
  return decodeURIComponent(
    cookieString ? cookieString.toString().replace(/^[^=]+./, '') : ''
  );
};
